import * as React from 'react';
import {RawTransactionRow} from 'src/RawTransactionRow';
import type {BasicRawTransactionFragment} from '@transactions/graphql';

type Props = {
  transactions: BasicRawTransactionFragment[];
  selectedIds?: ReadonlyArray<string>;
  onClick?: (transaction: BasicRawTransactionFragment) => void;
  onLongPress?: (transaction: BasicRawTransactionFragment) => void;
  className?: string;
  showProcessedStatus?: boolean;
  // When provided, renders in place of each row's amount display — used to show
  // an editable allocation control per row. Rows are non-navigable in this mode.
  renderAmount?: (transaction: BasicRawTransactionFragment) => React.ReactNode;
  // Render a copy-to-clipboard affordance beside each row's description.
  copyDescription?: boolean;
  // Select mode's leading check column (see RawTransactionRow).
  selectMode?: boolean;
};

const RawTransactionList = ({
  transactions,
  selectedIds = [],
  className,
  onClick,
  onLongPress,
  showProcessedStatus = false,
  renderAmount,
  copyDescription = false,
  selectMode,
}: Props) => {
  const selectedIdSet = React.useMemo(
    () => new Set(selectedIds),
    [selectedIds],
  );

  return (
    <div className={className}>
      {transactions.map((transaction) => {
        const isSelected = selectedIdSet.has(transaction._id);
        return (
          <RawTransactionRow
            key={transaction._id}
            rawTransaction={transaction}
            selected={isSelected}
            onClick={onClick ? () => onClick(transaction) : undefined}
            href={
              onClick || renderAmount
                ? undefined
                : `/raw-transactions/${transaction._id}`
            }
            onLongPress={() => onLongPress && onLongPress(transaction)}
            showProcessedStatus={showProcessedStatus}
            renderAmount={renderAmount}
            copyDescription={copyDescription}
            selectMode={selectMode}
          />
        );
      })}
    </div>
  );
};

export default RawTransactionList;
